function getURLVar(key) {
  var value = [];
  var query = String(document.location).split('?');
  if (query[1]) {
    var part = query[1].split('&');
    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');
      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }
    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');
  }
});
function miniQtyPlus(e){
  e.preventDefault();
  var parent = $(this).parent();
  var qty = parseInt(parent.data('quantity'));
  parent.find('input').val(qty + 1);
  parent.find('input').trigger('change');
}
function miniQtyMinus(e){
  e.preventDefault();
  var parent = $(this).parent();
  var qty = parseInt(parent.data('quantity'));
  parent.find('input').val(qty - 1);
  parent.find('input').trigger('change');
}
function closeMiniCart(e){
  e.preventDefault();
  if(jQuery('#cart.show').length> 0) {
    jQuery('#cart.show>button').dropdown('toggle');
  }
}
function initMiniCartEvents(){
  jQuery('.cart-quantity-input .qplus').on('click',miniQtyPlus);
  jQuery('.cart-quantity-input .qminus').on('click',miniQtyMinus);
  jQuery('#cart .dropdown-close').on('click',closeMiniCart);

  // turn off events first, before setting new ones
  jQuery('.cart-quantity-input>input').on('change', function (e) {
    e.preventDefault();
    $('#cart').addClass('mini-cart-loading');
    var inp = $(this);
    let line = inp.data('line');
    let quantity = inp.val();
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function(cart) {
        if (window.privyContest && window.privyContest.isContestEnabled() && !window.privyContest.isOutOfStock) {
          window.initPrivyContest();
        }
        refreshHeaderCart();
        if(location.href.indexOf('/cart') >= 0) {
          location.reload();
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
      }
    });
  });
}
function refreshHeaderCart(){
  $.getJSON('/cart.js', function(cart) {
    $('#cart > ul').load('/ #cart > ul li',function(){
      $('#cart').removeClass('mini-cart-loading');
      initMiniCartEvents();
    });
    $('#cart > button').button('reset');
    $('#cart-total').html(cart.item_count);
    setTimeout(function(){
    $('#cart-total').html(cart.item_count);
    },100);
    Currency.convertAll(shopCurrency, Currency.cookie.read());
    // additionally, any updates to header cart need to be checked against trade collection minimums
    if ($('#button-trade-cart').length > 0) {
      setTimeout(function() {
        let $button = $('#button-trade-cart'),
            reDigit = /[\d\,\.]+/g,
            discount = 1 - (parseInt($('input[name="_discount_rate"]').val()) / 100),
            sessionTotal = localStorage.sessionCart != undefined ? getSessionCartTotal(JSON.parse(localStorage.sessionCart)) : 0,
            minimum = parseFloat($('form#form_buy input[name="_discount_minimum"]').val()),
            cartDiscountTotal = $('td.td-discount-total').length > 0 ? parseFloat($('td.td-discount-total').text().match(reDigit)[0]) : 0,
            bool = isAddToCartDisabled((sessionTotal * discount) + cartDiscountTotal, minimum);

        $button.toggleClass('disabled', bool).prop('disabled', bool);
      }, 1000);
    }
  });
}
function initCartEvents(){
  jQuery('#cart_form .c-qty input[name="updates[]"]').on('change', function (e) {
    e.preventDefault();
    $('#cart_preloader').show();
    var inp = $(this);
    let line = inp.data('line');
    let quantity = inp.val();
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function(cart) {
        $('#cart_form').load('/cart #cart_form',function () {
          initCartEvents();
          toastr.success('Quantity updated successfully.')
          $('#cart_preloader').hide();
        });
        refreshHeaderCart();
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
  });
}

// add to cart event functions
addToCartBeforeSend = function(btn) {
  btn.button('loading');
}

addToCartComplete = function(btn) {
  btn.button('reset');
}

addToCartSuccess = function(json) {
  $('.alert, .text-danger').remove();
  $('.form-group').removeClass('has-error');
  handleFormErrors(json);

  // for pdps with safety information on mobile, a popup opens when a product 
  // is added to cart.  This conditional handles the popup and the header cart animations.
  if ($("#pdp-warning-popup").length > 0 && $(window).width() <= 767) {
    const $warningPopup = $('#pdp-warning-popup');
    const $warningPopupClose = $('#pdp-warning-popup .close');

    let interval;
    const timer = function() {
        interval = setInterval(function() {
            $warningPopup.slideUp(250);
            handleHeaderCartAnimation();
            clearInterval(interval);
        }, 15000);
    };

    // guard against empty nodes
    if ($warningPopupClose.length > 0) {
      $warningPopupClose.on('click', function() {
          $warningPopup.slideUp(250);
          clearInterval(interval);
          handleHeaderCartAnimation();
      });
    }

    $warningPopup.slideDown(250);
    if (!interval) {
      timer();
    }

  } else {
    handleHeaderCartAnimation();
  }
}

addToCartError = function(xhr, ajaxOptions, thrownError) {
  if(xhr.status == 422 ) {
    toastr.warning(xhr.responseJSON.description);
  } else {
    alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
  }
}

handleFormErrors = function(json) {
  if (json['error']) {
    if (json['error']['option']) {
      for (i in json['error']['option']) {
        var element = $('#input-option' + i.replace('_', '-'));
        if (element.parent().hasClass('input-group')) {
          element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
        } else {
          element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
        }
      }
    }

    if (json['error']['recurring']) {
      $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
    }

    // Highlight any found errors
    $('.text-danger').parent().addClass('has-error');
  }
}

handleHeaderCartAnimation = function() {
  $('html, body').animate({ scrollTop: 0 }, 'slow');
  $('#cart').removeClass('open');
  $('#cart > button').attr('aria-expanded','false');
  $('#cart').addClass('mini-cart-loading');
  $.getJSON('/cart.js', function(cart) {
    $('#cart-total').html(cart.item_count);
    $('#cart > button .total-price').html(cart.price);
    Currency.convertAll(shopCurrency, Currency.cookie.read());
  });


  $('#cart > ul').load('/ #cart > ul li', function(){
    $('#cart').removeClass('mini-cart-loading');
    $('#cart > button').dropdown('toggle');
    initMiniCartEvents();
  });
}

addToCart = function(btn, data, callbacks = {}) {
  $.ajax({
    url: '/cart/add.js',
    type: 'post',
    data: data,
    dataType: 'json',
    beforeSend: addToCartBeforeSend(btn),
    complete: addToCartComplete(btn),
    success: function(json) {
      addToCartSuccess(json);
      if (window.privyContest && window.privyContest.isContestEnabled() && !window.privyContest.isOutOfStock) {
        window.initPrivyContest();
      }
      if (callbacks.onSuccess) {
        callbacks.onSuccess(params = {});
      }
    },
    error: function(xhr, ajaxOptions, thrownError) {
      addToCartError(xhr, ajaxOptions, thrownError);

      if (callbacks.onError) {
        callbacks.onError(params = {});
      }
    }
  });
}

// trade collection functions
getSessionCartTotal = function(sessionCart) {
  let sessionCartTotal = 0;
  for (key in sessionCart) {
    sessionCart[key].variants.forEach(variant => {
      sessionCartTotal += variant.totalPrice;
    });
  }
  return sessionCartTotal;
}

$(function() {
  toastr.options.progressBar = true;
  toastr.options.closeButton = true;

  //stickyMenu();
  var sticky_menu = $('#sticky-menu').attr('data-sticky');
  if (sticky_menu == 1) {
    var headerSpaceH = $('header').outerHeight(true);
    $('header').after('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');
  }
  // Scroll
  var currentP = 0;
  var stickyOffset = 0;
  stickyOffset = $('header').offset().top;
  stickyOffset += $('header').outerHeight();
  stickyOffset += 30;
  $(window).on('scroll', function() {
    var headerH = $('header').height();
    var scrollP = $(window).scrollTop();
    var winInnW = window.innerWidth;
    if( winInnW > 991 ){
      if(scrollP != currentP){
        //Sticky header
        if (sticky_menu==1){
          if(scrollP >= stickyOffset){
            $('.fix').addClass('fix-header');
            $('.headerSpace').removeClass('unvisible');
          } else {
            $('.fix').removeClass('fix-header');
            $('.headerSpace').addClass('unvisible');
          }
        }
        currentP = $(window).scrollTop();
      }
    }
  });

  // color swatch js snippet
  $('.swatch :radio').on('change', function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });

  $(document).on('click', '#cart > .dropdown-menu', function (e) {
    e.stopPropagation();
  });

  // product page add to cart
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    addToCart($(this), $(this).parents('form').first().find('input[type=\'text\'] , select'));
  });

/*
 * TW Custom bundle functions and processes
 * For the custom bundle component and featured products component
*/

  processBundleData = function(jQSelector, properties) {
    return {
      items: $(jQSelector).map(function() {
        return {
          quantity: 1,
          id: $(this).attr('value'),
          properties: properties
        }
      }).get()
    }
  }

  // reorder products
  $('.btn-reorder').on('click', function(e) {
    let $btn = $(this), productIds = [], productQtys = [], data = {items: []};

    // first check is from customers/order.liquid template
    if ($('input.checkbox-input:checked').length > 0) {
      $('input.checkbox-input:checked').each(function() {
        productIds.push($(this).attr('pid'));
        productQtys.push($(this).attr('qty'));
      });
    } else {
      // second check is from customers/account.liquid template
      if ($btn.attr('orderProductIds')) {
        productIds = $btn.attr('orderProductIds').split(',');
        productQtys = $btn.attr('orderProductQtys').split(',');
      }
    }

    for (var i = 0; i < productIds.length; i++) {
      data.items.push({
        quantity: productQtys[i],
        id: productIds[i]
      });
    }
    onSuccess = function() {
      location = '/checkout';
    }
    addToCart($btn, data, { onSuccess: onSuccess });
  });

  // custom bundle add to cart (snippets/tw-custom-bundle.liquid)
  $('#button-bundle-cart').on('click', function(e) {
    e.preventDefault();
    const data = processBundleData('.tw-custom-bundle-form input:checked', window.customBundleGlobal);
    var btn = $(this);
    addToCart(btn, data);
  });

  // featured products bundle add to cart (snippets/featured-products-sticky.liquid)
  $('#button-fp-bundle').on('click', function(e) {
    e.preventDefault();
    const data = processBundleData('.tw-custom-bundle-form input[fpBundle="checked"]', window.fpBundleGlobal);
    var btn = $(this);
    addToCart(btn, data);
  });

  /*
   * Custom add to cart from trade collection pages
  */

  $('#button-trade-cart').on('click', function(e) {
    e.preventDefault();
    const btn = $(this);
    const sessionCartArr = [];
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.location.hostname.indexOf('uk') > -1 ? 'GBP' : 'USD',
        minimumFractionDigits: 2
    });
    const properties = {
      '_trade_account': true,
      '_discount': parseFloat($('input[name="_discount_rate"]').val() / 100),
      '_promo_code': $('input[name="discount"]').val()
    };

    // need to map all variants of all entries to sessionCartArr
    Object.entries(JSON.parse(localStorage.sessionCart)).forEach(function(entry) {
      // each entry [productID, {variants: []}] pushed to sessionCartArr
      entry[1].variants.forEach(variant => {
        sessionCartArr.push({
          quantity: variant.quantity * variant.productType,
          id: variant.id,
          properties: properties
        });
      });
    });

    onSuccess = function() {
      let $form = $('form.product-add-cart-form');
      let discount_rate = parseFloat($form.find('input[name="_discount_rate"]').val());
      // clear session cart and total
      localStorage.removeItem('sessionCart');
      localStorage.removeItem('sessionTotal');
      /* reset values */

      // clear quantity
      $('.quantity-inputs input[name="quantity"]').val('0');

      // for all product-type dropdowns
      $('select.product-type').each(function() {
        // if value="1" is not disabled (in stock)
        if ($(this).children('option').first().attr('disabled') == undefined) {
          // remove all instances of 'selected'
          $(this).children('option').attr('selected', false);
        }
      });

      // update all product unit price
      $('span.product-unit-price').each(function() {
        // if single unit is already selected, no need to update
        if (formatter.format($(this).attr('unitPrice')/100) != $(this).text()) {
          // get discount and node to place discount
          let unitPrice = parseFloat($(this).attr('unitPrice'));
          let discount = unitPrice * (discount_rate/100);
          let $productUnitDiscount = $(this).next();

          // update text
          $(this).text(formatter.format(unitPrice / 100));
          $productUnitDiscount.text(formatter.format(discount /100));
        }
      });

      // set totals and discounts to zero
      $('span.trade-col-total').text(formatter.format(0));
      $('span.total-price-amount').text(formatter.format(0));
      $('span.total-price-discount').text(formatter.format(0));
      $('span.trade-col-discount-total').text(formatter.format(0));
      $('.total-discount-price').removeClass('discount-added');

      // minimize the sticky bar
      $('.sticky-header-container').removeClass('prods-visible');
      $('#ot-sdk-btn-floating.ot-floating-button').css({transitionDuration: '0s'});
      $('.sticky-content').animate({height: 'hide'}, 250);
    }

    // add sessionCart items to cart
    addToCart(btn, {items: sessionCartArr}, { onSuccess: onSuccess });
  });

  /*
    * End trade collection pages
  */

  if (window.privyContest && window.privyContest.isContestEnabled() && !window.privyContest.isOutOfStock) {
    function wait(count) {
      // what if the campaign stopped or privy is down?? No memory leaks!
      if (count == 10) {
          return false;
      }
      // if query selector is loaded, run observer
      if (document.querySelector('div#privy-container') != null) {
          window.initPrivyContest();
      } else {
          // else, keep waiting
          setTimeout(function() {wait(count + 1)}, 1000);
      }
    }

    // check if hat has been removed from cart; if so, ignore
    if (!window.privyContest.hasCookie('privy_signedup_')) {
      setTimeout(function() {wait(0)}, 500);
    }
  }

  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');
  }

  /*
   * Related to the header-5.liquid snippet, this adds the collection title
   * and description to the header collection image.
   *
   * Collection title and description derive from collection.liquid template.
  */
  if ($(".header-top .child-tag-container").length == 0) {
    $(".header-top").append('<div class="container-fluid px-0 max-width" style="height: 100%;"><div class="collection-content with-pad-section on-hero" style="color: white; z-index: 2"><div class="row no-gutters title-and-summary"><div class="col-12 col-md-10 col-lg-8 contain"></div></div></div></div>');
      var container = $(".collection-content .contain");
      var page_title = $("#content > h1");
      var page_description = $("#content > .category-description");
      if (page_title.length > 0) {
          page_title.appendTo(container);
      }
      if (page_description.length > 0) {
          page_description.appendTo(container);
      }
  }

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();
    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search */
  function headerSearchTrigger(){
    var url = '/search';

    var value = $('#search input[name=\'q\']').val();
    if (value == "Search all products..." || value ==""){
      jQuery('#search input[name=\'q\']').focus();
      return false;
    } else {
      value = value.trim().replace(new RegExp(' ', 'g'),' OR ');
      url += '?type=product%2Carticle&options[unavailable_products]=show&q=' + encodeURIComponent(value);
    }
    location = url;
  }
  $('#search input[name=\'q\']').parent().find('button').on('click', function() {
    headerSearchTrigger();
  });

  $('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.key == 'Enter') {
      headerSearchTrigger();
    }
  });

  function addItemToHeaderSearch(item, priceHTML = '') {
    return `<li>
    <div class="ssug-item">
      <div class="ssug-img-container">
        <div class="ssug-img" style="background-image:url(${item.image});"></div>
      </div>
      <div class="ssug-desc-container">
        <p class="ssug-name">${item.title}</p>
        <p class="ssug-tags">${item.tags ? item.tags.join(", ") : ""}</p>
        ${priceHTML}
      </div>
      <a class="ssug-link" href="${item.url}"></a>
    </div>
  </li>`
  }

  function hideSuggestions(event){
    $('.search-suggestions').removeClass('show');
    $('html').off('click',hideSuggestions);
  }

  $('#search input[name=\'q\']').on('keyup', function(e) {
    var term = $(this).val();
    var currencySymbol = $('.search-suggestions').data('currency');
    if (term.length > 0) {
      $.getJSON("/search/suggest.json", {
        q: term,
        resources: {
          "types": ["product", "article"],
          "limit": 4,
          "unavailable_products": "show"
        }
      }).done(function(response) {
        let products = response.resources.results.products,
            articles = response.resources.results.articles,
            html = ``;

        // for results with products AND articles
        if (products.length > 0 && articles.length > 0) {
          for (let i=0; products.length > 2 ? i < 2 : i < products.length; i++) {
            let product = products[i];
            let productPriceHTML = parseFloat(product.price) > 1 ? `<p class="ssug-price">${currencySymbol + product.price}</p>`: ``
            html += addItemToHeaderSearch(product, productPriceHTML);
          }
          for (let i=0; articles.length > 2 ? i < 2 : i < articles.length; i++) {
            let article = articles[i];
            html += addItemToHeaderSearch(article);
          }

          // for results with just products
        } else if (products.length > 0 && articles.length == 0) {
          for (let i=0; i < products.length; i++) {
            let product = products[i];
            let productPriceHTML = parseFloat(product.price) > 1 ? `<p class="ssug-price">${currencySymbol + product.price}</p>`: ``
            html += addItemToHeaderSearch(product, productPriceHTML);
          }

          // for results with just articles
        } else if (articles.length > 0) {
          for (let i=0; i < articles.length; i++) {
            let article = articles[i];
            html += addItemToHeaderSearch(article);
          }

          // no results
        } else {
          $('.search-suggestions').removeClass('show');
          $('html').off('click',hideSuggestions);
        }
        $('.search-suggestions>ul').html(html);
        $('.search-suggestions').addClass('show');
        $('html').on('click',hideSuggestions);
      });
    }
  });
  $('.search-suggestions a.search-view-all').click(function (e) {
    e.preventDefault();
    headerSearchTrigger();
  });
  $('.search-suggestions').click(function (e) {
    e.stopPropagation()
  })

  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();
    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());
    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });
  // Product List
  $('#list-view').on('click', function() {
    $('.custom-products').removeClass('custom-products-row');
    $(this).addClass('selected');
    $('#grid-view').removeClass('selected');
    $('#content .product-grid > .clearfix').remove();
    $('#content .product-grid').attr('class', 'product-layout product-list');
    $('#content .product-list .col-image').addClass('col-sm-4 col-12');
    $('#content .product-list .col-des').addClass('col-sm-8 col-12');
    localStorage.setItem('display', 'list');
  });
  // Product Grid
  $('#grid-view').on('click', function() {
    $('.custom-products').addClass('custom-products-row');
    $(this).addClass('selected');
    $('#list-view').removeClass('selected');
    cols = $('#column-right, #column-left').length;
    $('#content .product-grid .col-image').removeClass('col-sm-4 col-sms-4 col-smb-12');
    $('#content .product-grid .col-des').removeClass('col-sm-8 col-sms-8 col-smb-12');
    localStorage.setItem('display', 'grid');
  });
  if (localStorage.getItem('display') == null) {
    $('#list-view').trigger('click');
  } else if (localStorage.getItem('display') == 'grid') {
    $('#grid-view').trigger('click');
  } else {
    $('#list-view').trigger('click');
  }
  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.key == 'Enter') {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });
  // Tooltips on hover
  $('body').tooltip({selector: '[data-toggle="tooltip"]'});
});

// Cart add remove functions
var cart = {
  'add': function(product_id, quantity) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        var btn = $(this);
        $('.btn-cart[data-product-id='+product_id+']').button('loading');
      },
      complete: function() {
        setTimeout(function () {
          $('.btn-cart[data-product-id='+product_id+']').button('reset');
        },3000);
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        if (window.privyContest && window.privyContest.isContestEnabled() && !window.privyContest.isOutOfStock) {
          window.initPrivyContest();
        }
        if (json['redirect']) {
          location = json['redirect'];
        }

        //toastr.success('Item added to your basket.','Congratulations!')
        $('#cart').removeClass('open');
        $('#cart > button').attr('aria-expanded','false');
        $('#cart').addClass('mini-cart-loading');

        $.getJSON('/cart.js', function(cart) {
          setTimeout(function () {
            $('#cart-total').html(cart.item_count);
            $('#cart > button .total-price').html(cart.total_price);
            //$('#cart > button').html('<i class="ion-bag"></i><span id="cart-total">' + cart.item_count + '</span>');
          }, 100);
          Currency.convertAll(shopCurrency, Currency.cookie.read());
        });

        $('#cart > ul').load('/ #cart > ul li', function(){
          $('#cart').removeClass('mini-cart-loading');
          $('#cart > button').dropdown('toggle');
          $('.btn-cart[data-product-id='+product_id+']').button('reset');
          initMiniCartEvents();
        });

        if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout' || location.pathname === '/cart'|| location.pathname === '/checkout') {
          location.href = '/cart';
        }
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.error('Product is out of stock, Please try again later.')
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  },
  'remove': function(key) {
    $.ajax({
      url: '/cart/update.js',
      type: 'post',
      data: 'updates['+key+']=0',
      dataType: 'json',
      success: function(json) {
        $('#cart > button').button('reset');
        if (window.privyContest && window.privyContest.isContestEnabled() && !window.privyContest.isOutOfStock) {
          window.initPrivyContest();
        }
        setTimeout(function () {
          $('#cart-total').html(json['item_count']);
          $('#cart > button .total-price').html(json['total_price']);
        }, 100);
        Currency.convertAll(shopCurrency, Currency.cookie.read());
        if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout' || location.pathname === '/cart'|| location.pathname === '/checkout') {
          location.href = '/cart';
        } else {
          $('#cart > ul').load('/ #cart > ul li',function(){
            initMiniCartEvents();
          });
        }
        // handle enabling/disabling Add To Cart button on trade pages
        if ($('#button-trade-cart').length > 0) {
          setTimeout(function() {
            // check if the discount total is still available (if not, cart is empty)
            let $button = $('#button-trade-cart'),
            reDigit = /[\d\,\.]+/g,
            discount = 1 - (parseInt($('input[name="_discount_rate"]').val()) / 100),
            sessionTotal = localStorage.sessionCart != undefined ? getSessionCartTotal(JSON.parse(localStorage.sessionCart)) : 0,
            minimum = parseFloat($('form#form_buy input[name="_discount_minimum"]').val()),
            cartDiscountTotal = $('td.td-discount-total').length > 0 ? parseFloat($('td.td-discount-total').text().match(reDigit)[0]) : 0,
            bool = isAddToCartDisabled((sessionTotal * discount) + cartDiscountTotal, minimum);

            $button.toggleClass('disabled', bool).prop('disabled', bool);
          }, 1000);
        }
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  }
}

var wishlist = {
  'add': function(product_id) {
    $.ajax({
      url: 'index.php?route=account/wishlist/add',
      type: 'post',
      data: 'product_id=' + product_id,
      dataType: 'json',
      success: function(json) {
        $('.alert-dismissible').remove();
        if (json['redirect']) {
          location = json['redirect'];
        }
        if (json['success']) {
          $('body').before('<div class="alert alert-success alert-dismissible"><i class="fa fa-check-circle"></i> ' + json['success'] + ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>');
        }
        $('#wishlist-total .count').html(json['total']);
        $('#wishlist-total').attr('title', json['total']);
        $('html, body').animate({ scrollTop: 0 }, 'slow');
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  },
  'remove': function() {
  }
}

/* Agree to Terms */
$(document).on('click', '.agree', function(e) {
  e.preventDefault();
  $('#modal-agree').remove();
  var element = this;
  $.ajax({
    url: $(element).attr('href'),
    type: 'get',
    dataType: 'html',
    success: function(data) {
      html  = '<div id="modal-agree" class="modal">';
      html += '  <div class="modal-dialog">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
      html += '      </div>';
      html += '      <div class="modal-body">' + data + '</div>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';
      $('body').append(html);
      $('#modal-agree').modal('show');
    }
  });
});

// Autocomplete */
(function($) {
  $.fn.autocomplete = function(option) {
    return this.each(function() {
      this.timer = null;
      this.items = new Array();
      $.extend(this, option);
      $(this).attr('autocomplete', 'off');
      // Focus
      $(this).on('focus', function() {
        this.request();
      });
      // Blur
      $(this).on('blur', function() {
        setTimeout(function(object) {
          object.hide();
        }, 200, this);
      });
      // Keydown
      $(this).on('keydown', function(event) {
        switch(event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });
      // Click
      this.click = function(event) {
        event.preventDefault();
        value = $(event.target).parent().attr('data-value');
        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      }
      // Show
      this.show = function() {
        var pos = $(this).position();
        $(this).siblings('ul.dropdown-menu').css({
          top: pos.top + $(this).outerHeight(),
          left: pos.left
        });
        $(this).siblings('ul.dropdown-menu').show();
      }
      // Hide
      this.hide = function() {
        $(this).siblings('ul.dropdown-menu').hide();
      }
      // Request
      this.request = function() {
        clearTimeout(this.timer);
        this.timer = setTimeout(function(object) {
          object.source($(object).val(), $.proxy(object.response, object));
        }, 200, this);
      }
      // Response
      this.response = function(json) {
        html = '';
        if (json.length) {
          for (i = 0; i < json.length; i++) {
            this.items[json[i]['value']] = json[i];
          }
          for (i = 0; i < json.length; i++) {
            if (!json[i]['category']) {
              html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
            }
          }
          // Get all the ones with a categories
          var category = new Array();
          for (i = 0; i < json.length; i++) {
            if (json[i]['category']) {
              if (!category[json[i]['category']]) {
                category[json[i]['category']] = new Array();
                category[json[i]['category']]['name'] = json[i]['category'];
                category[json[i]['category']]['item'] = new Array();
              }
              category[json[i]['category']]['item'].push(json[i]);
            }
          }
          for (i in category) {
            html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';
            for (j = 0; j < category[i]['item'].length; j++) {
              html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
            }
          }
        }
        if (html) {
          this.show();
        } else {
          this.hide();
        }
        $(this).siblings('ul.dropdown-menu').html(html);
      }
      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));
    });
  }
  $(document).ready(function() {
    var search_inp = $('#search .search-content input').first();
    if(search_inp !== undefined){
      search_inp.on('focus',function(){
        $(this).parent().addClass('search-focused');
      });
      search_inp.on('blur',function(){
        $(this).parent().removeClass('search-focused');
      });
    }

    initCartEvents();
    initMiniCartEvents();

    //IE11
    if(!!window.MSInputMethodContext && !!document.documentMode){
      $('.grid-style .images-container .product-image > img').each(function () {
        $(this).after('<div class="img" style="background-image:url('+$(this).attr('src')+')"></div>')
        $(this).hide();
      })
    }

  });
})(window.jQuery);


function updateDiscountTotal() {
  if($('#cart-discount-out-total').length===0) {
    return
  }
    var currency = $('#cart-discount-out-total').data('currency');
    var no_discount = true;
    var currentDiscount = sessionStorage.getItem("currentDiscount");

    if (currentDiscount) {
        currentDiscount = JSON.parse(currentDiscount);
        var dcdata = sessionStorage.getItem(currentDiscount.title.toLowerCase()+'-dcdata');
        var cart = sessionStorage.getItem('cart');
        if(cart){
          cart = JSON.parse(cart);
        }
        if(dcdata){
            dcdata = JSON.parse(dcdata);
            no_discount = false;
            // let discount_value = parseFloat(dcdata.value.replace('-',''))
            var discount_value = Math.abs(currentDiscount.value);
            if(dcdata.target_selection === 'entitled'){
              discount_value = -1;
            }
            if(discount_value === -1){
              $('#cart-discount-out-total').hide();
              $('#cart-grand-total-discount').hide();
              $('#cart-discount-out-total').parent().show();
              $('#cart-grand-total-value').parent().parent().hide();
            }else {
              $('#cart-discount-out-total').html("- " + currency + discount_value.toFixed(2));
              $('#cart-discount-out-total').parent().show();
              var total = parseFloat($('#cart-grand-total-value').data('value'));
              $('#cart-grand-total-discount').html(currency + (total / 100 - discount_value).toFixed(2));
              $('#cart-grand-total-discount').show();
              $('#cart-grand-total-value').hide();
            }
            $('#removeDiscount').click(function (e) {
                setTimeout(function () {
                    updateDiscountTotal();
                }, 500);
            });
        }
    }
    if(no_discount){
        $('#cart-discount-out-total').html('');
        $('#cart-discount-out-total').parent().hide();
        $('#cart-grand-total-discount').hide();
        $('#cart-grand-total-value').show();
        $('#cart-grand-total-value').parent().parent().show();
    }
}

function adjustHeader5(){
  var window_pos = $(window).scrollTop();
  var header_pos = $('header.hd5').offset().top;

  if(window_pos > header_pos){
    if (!$('header.hd5').hasClass('is-fixed')) {
      $('header.hd5').addClass('is-fixed');
    }
  } else {
    if ($('header.hd5').hasClass('is-fixed')) {
      $('header.hd5').removeClass('is-fixed');
    }
  }
}

$(function() {
    if ($('header.hd5').length>0) {
      adjustHeader5();
      $(window).on('scroll', function() {
        adjustHeader5();
      })
    }
});